// @ts-expect-error TS(2306) FIXME: File '/Users/cedric/Dev/repositories/toktokdoc/wor... Remove this comment to see the full error message
import ToktokdocLib from '@saas/lib/toktokdoc-lib/web'

/**
 * @async
 * @description search patients
 * @param {string} search string to search
 * @returns {Array<Object>} patients list corresponding to the search string with id and libelle
 */
export const getSearchPatients = (hcsId: string) => async (search: any) => {
    try {
        const HCS = await ToktokdocLib.HealthCareService.findOne(hcsId)
        let result = await HCS.getPaginatedPatients(null, 10, search, null, {})
        result = result.map((patient: any) => ({
            libelle: `${patient.fullName} - ${patient.formatedBirthDate}`,
            id: patient.id,
        }))
        return result
    } catch (error) {
        // @ts-expect-error TS(2571) FIXME: Object is of type 'unknown'.
        console.log(`[searchPatients] error catched | message : ${error.message}`)
    }
    return false
}
